export class UserPreferences {
    public descriptionCity: string;
    public idCity: string;
    public filterByGenresLike: boolean;
    public genresDescription: string[];
    public genresValue: string [];
    public filterIncludeLives: boolean;
}